import { render, staticRenderFns } from "./modal-brands.vue?vue&type=template&id=f6803722&scoped=true"
import script from "./modal-brands.vue?vue&type=script&lang=js"
export * from "./modal-brands.vue?vue&type=script&lang=js"
import style0 from "./modal-brands.vue?vue&type=style&index=0&id=f6803722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6803722",
  null
  
)

export default component.exports